export default function ErrorMessage(){
  return {
    restrict: "E",
    scope:{
      worker: "=",
    },
    template: require("./ErrorMessage.html"),
    controller: function($scope, ErrorService){
      $scope.showDiagnosticMessage = function(){
        ErrorService.showError($scope.worker.getError());
      };
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/ErrorMessage.js